import { useState } from "react";
import UseGetData from "../../../../Components/Hooks/useFetchData";
import SearchBar from "../../../../Components/Utils/SearchBar";
import { CancelButton, CreateButton, FilterButton, SubmitButton } from "../../../../Components/Utils/Buttons";
import DataTable from "../../../../Components/Others/DataTable";
import { Link } from "react-router-dom";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import MoreOptions from "../../../../Components/Utils/MoreOptions";
import CustomDataTable from "../../../../Components/Others/CustomDataTable";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import { useFormik } from "formik";
import * as yup from 'yup';
import UseGetDataSearch from "../../../../Components/Hooks/useFetchDataBySearch";
import { GetAccess, GetRole, CheckEditAction, CheckDeleteAction } from "../../../../Components/Utils/roles";
import PremiumTable from "../../../../Components/Others/PremiumTable";
import { useDeleteData } from "../../../../Components/Hooks/useDeleteData";
import ModalContainer from "../../../../Components/Others/ModalContainer";
import moment from "moment";

// Contract Table Row Component
const ContractTableRow = ({
  row,
  pageIndex,
  searchQuery,
  canEdit,
  canDelete,
  handleDelete,
}) => {
  const formattedDate = row.date ? moment(row.date).format("DD-MMM-YYYY") : "--";
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handle = async () => handleDelete("/contracts/" + `${row.contractId}`, setIsModalOpen);
  return (
    <>
    <tr className="bg-white hover:bg-white/80 transition-colors align-middle">
      {/* ID */}
      <td className="p-4 align-middle border-t border-b border-l border-gray-200/60 rounded-tl-xl rounded-bl-xl font-semibold text-sm text-gray-800 whitespace-nowrap">
        {row.id || "N/A"}
      </td>

      {/* Contract Title */}
      <td className="p-4 align-middle border-t border-b border-gray-200/60 font-semibold text-sm text-gray-800 whitespace-nowrap">
        <Link
          to={`/procurement/contracts/view/${row.contractId}`}
          state={{
            data: row,
            pageIndex: pageIndex,
            searchQuery: searchQuery,
          }}
          className="hover:underline text-sm font-bold text-gray-800"
        >
          {row.contractTitle || row.title || "N/A"}
        </Link>
      </td>

      {/* Customer Name */}
      <td className="p-4 align-middle border-t border-b border-gray-200/60 text-xs font-semibold text-gray-600">
        {row.customerName || "N/A"}
      </td>

      {/* Start Date */}
      <td className="p-4 align-middle border-t border-b border-gray-200/60 text-xs font-semibold text-gray-600 whitespace-nowrap">
        {row.startDate ? moment(row.startDate).format("DD-MMM-YYYY") : "--"}
      </td>

      {/* End Date */}
      <td className="p-4 align-middle border-t border-b border-gray-200/60 text-xs font-semibold text-gray-600 whitespace-nowrap">
        {row.endDate ? moment(row.endDate).format("DD-MMM-YYYY") : "--"}
      </td>

      {/* Project Duration */}
      <td className="p-4 align-middle border-t border-b border-gray-200/60 text-xs font-semibold text-gray-600 whitespace-nowrap">
        {row.projectDuration || "--"}
      </td>

      {/* Status */}
      <td className="p-4 align-middle border-t border-b border-gray-200/60 whitespace-nowrap">
        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold border ${
          row.status === "Approved" || row.status === "Completed"
            ? "bg-emerald-50 text-emerald-700 border-emerald-100"
            : row.status === "Pending"
            ? "bg-amber-50 text-amber-700 border-amber-100"
            : "bg-gray-50 text-gray-600 border-gray-100"
        }`}>
          {row.status || "N/A"}
        </span>
      </td>

      {/* Action Buttons */}
      <td className="p-4 text-center align-middle border-t border-b border-r border-gray-200/60 rounded-tr-xl rounded-br-xl">
        <div className="flex items-center justify-center gap-1.5">
          {/* View */}
          <Link
            to={`/procurement/contracts/view/${row.contractId}`}
            state={{
              data: row,
              pageIndex: pageIndex,
              searchQuery: searchQuery,
            }}
            className="border border-blue-200 text-blue-600 hover:bg-blue-50 p-1.5 rounded-md transition-all duration-200 flex items-center justify-center"
            title="View details"
          >
            <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
            </svg>
          </Link>
          {/* Edit */}
          {CheckEditAction(row, "Contracts", canEdit) && (
            <Link
              to={`/procurement/contracts/edit/${row.contractId}`}
              state={{
                data: row,
                from: "/procurement/contracts",
                pageIndex: pageIndex,
                searchQuery: searchQuery,
              }}
              className="border border-sky-200 text-[#0ea5e9] hover:bg-sky-50 p-1.5 rounded-md transition-all duration-200 flex items-center justify-center"
              title="Edit Contract"
            >
              <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-5M18.5 2.5a2.121 2.121 0 113 3L12 15l-4 1 1-4 9.5-9.5z" />
              </svg>
            </Link>
          )}
          {/* Delete */}
          {CheckDeleteAction(row, canDelete) && (
            <button
              onClick={() => setIsModalOpen(true)}
              className="border border-red-200 text-red-500 hover:bg-red-50 p-1.5 rounded-md transition-all duration-200 flex items-center justify-center"
              title="Delete Contract"
            >
              <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
            </button>
          )}
        </div>
      </td>
    </tr>
    <ModalContainer
      visiable={isModalOpen}
      title="Warning"
      content={`Are you sure, ${row.ref} will be removed from Contracts!`}
      handleClick={() => handle()}
      closeModal={() => setIsModalOpen(false)}
    />
    </>
  );
};

// Contract Card Component
const ContractCard = ({
  row,
  pageIndex,
  searchQuery,
  canEdit,
  canDelete,
  handleDelete,
}) => {
  const formattedDate = row.date ? moment(row.date).format("DD-MMM-YYYY") : "--";
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handle = async () => handleDelete("/contracts/" + `${row.contractId}`, setIsModalOpen);
  return (
    <div className="relative border border-y-gray-200/50 border-r-gray-200/50 border-l-0 shadow-[0_4px_20px_rgba(0,0,0,0.05)] hover:shadow-[0_10px_30px_rgba(0,0,0,0.08)] transition-all duration-300 rounded-2xl bg-white p-5 flex flex-col gap-4 overflow-hidden border-l-4 border-l-purple-500">
      {/* Card Header */}
      <div className="flex justify-between items-start gap-4">
        <div className="flex flex-col">
          <Link
            to={`/procurement/contracts/view/${row.contractId}`}
            state={{
              data: row,
              pageIndex: pageIndex,
              searchQuery: searchQuery,
            }}
            className="text-gray-800 font-bold hover:underline text-sm"
          >
            {row.ref || "N/A"}
          </Link>
          <span className="text-[10px] text-gray-400 font-bold mt-0.5">{row.title || "N/A"}</span>
        </div>
        
        {/* Status Badge */}
        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold border ${
          row.status === "Approved" || row.status === "Completed"
            ? "bg-emerald-50 text-emerald-700 border-emerald-100"
            : row.status === "Pending"
            ? "bg-amber-50 text-amber-700 border-amber-100"
            : "bg-gray-50 text-gray-600 border-gray-100"
        }`}>
          {row.status || "N/A"}
        </span>
      </div>

      {/* Middle Grid */}
      <div className="bg-[#FAFAFC]/60 rounded-xl p-3.5 border border-gray-100 flex flex-col gap-2 text-xs">
        <div className="flex justify-between">
          <span className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">Customer</span>
          <span className="font-bold text-gray-700">{row.customerName || "N/A"}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">Duration</span>
          <span className="font-bold text-gray-700">{row.projectDuration || "--"}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">Start Date</span>
          <span className="font-bold text-gray-700">{row.startDate ? moment(row.startDate).format("DD-MMM-YYYY") : "--"}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">End Date</span>
          <span className="font-bold text-gray-700">{row.endDate ? moment(row.endDate).format("DD-MMM-YYYY") : "--"}</span>
        </div>
      </div>

      {/* Action Buttons Row */}
      <div className="flex items-center justify-between border-t border-gray-100 pt-3 mt-1">
        <Link
          to={`/procurement/contracts/view/${row.contractId}`}
          state={{
            data: row,
            pageIndex: pageIndex,
            searchQuery: searchQuery,
          }}
          className="border border-gray-200 text-gray-600 hover:bg-gray-50 px-3.5 py-1.5 rounded-lg transition-all duration-200 flex items-center gap-1.5 text-xs font-semibold"
        >
          <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
          </svg>
          View Details
        </Link>
        <div className="flex gap-2">
          {CheckEditAction(row, "Contracts", canEdit) && (
            <Link
              to={`/procurement/contracts/edit/${row.contractId}`}
              state={{
                data: row,
                from: "/procurement/contracts",
                pageIndex: pageIndex,
                searchQuery: searchQuery,
              }}
              className="border border-gray-200 text-gray-600 hover:bg-gray-50 px-3.5 py-1.5 rounded-lg transition-all duration-200 flex items-center gap-1.5 text-xs font-semibold"
            >
              <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-5M18.5 2.5a2.121 2.121 0 113 3L12 15l-4 1 1-4 9.5-9.5z" />
              </svg>
              Edit
            </Link>
          )}
          {CheckDeleteAction(row, canDelete) && (
            <button
              onClick={() => setIsModalOpen(true)}
              className="border border-red-100 text-red-500 hover:bg-red-50 px-3.5 py-1.5 rounded-lg transition-all duration-200 flex items-center gap-1.5 text-xs font-semibold"
            >
              <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
              </svg>
              Delete
            </button>
          )}
        </div>
      </div>
      <ModalContainer
        visiable={isModalOpen}
        title="Warning"
        content={`Are you sure, ${row.ref} will be removed from Contracts!`}
        handleClick={() => handle()}
        closeModal={() => setIsModalOpen(false)}
      />
    </div>
  );
};

function ContractsIndex(){
    const [page,setPage]=useState(1)
    const [pageCount,setPageCount]=useState(20)
    const [filter, setFilter] = useState(false);
    const [showFilterDialog, setShowFilterDialog] = useState(false);
    const [viewMode, setViewMode] = useState(localStorage.getItem("contractsViewMode") || "table");
    const [filterProps, setFilterProps] = useState({
      category:"",
      subCategory:""
    });
    const [params, setParams] = useState({
      page: page,
      per_page: pageCount,
      search:"",
      category:"",
      subCategory:""
    });
    const clearFilter = ()=> {
      setParams({...params,category:"", subCategory:""})
        setFilter(false)
    }
  
    const formik = useFormik({
      enableReinitialize: true,
      initialValues: filterProps,
      validateOnChange: false,
      validateOnBlur: false,
      validationSchema: yup.object({
        // email: yup.string().required('Email is required!'),
      }),
      onSubmit: async (value, { resetForm }) => {
        console.log("ffff",value);
        setParams({...params,category:value.category, subCategory:value.subCategory})
        closeFilterDialog();
        setFilter(true)
        setFilterProps({
          category: "",
          subCategory: ""
        });
      }
    })
  
    const { data, totalCount, getData, dataLoading } = UseGetDataSearch('/contracts/',params);
    console.log(data,'dddd');

    const defaultHeaders = [
      {
        title: "ID",
        width: "5%",
        field: "id",
        textAlign: "left",
        rowAlign: "left",
      },
      {
        title: "Contract Title",
        width: "10%",
        isLink: true,
        id: "id",
        link: '/procurement/contracts/view/',
        field: "contractTitle",
        textAlign: "left",
        rowAlign: "left",
      },
      {
        title: "Customer Name",
        width: "10%",
        field: "customerName",
        textAlign: "left",
        rowAlign: "left",
      },
      {
        title: "Start Date",
        width: "10%",
        field: "startDate",
        textAlign: "left",
        rowAlign: "left",
      },
      {
        title: "End Date",
        width: "10%",
        field: "endDate",
        textAlign: "left",
        rowAlign: "left",
      },
      {
        title: "Project Duration",
        width: "10%",
        field: "projectDuration",
        textAlign: "left",
        rowAlign: "left",
      },
      {
        title: "Status",
        width: "10%",
        field: "status",
        textAlign: "left",
        rowAlign: "left",
      },
      {
        title: "Action",
        width: "5%",
        field: "action",
        textAlign: "left",
        rowAlign: "left",
        contents:{
          // fetcher:getData,
          id:"id",
          removeValue:"contractTitle",
          url:`/contracts/`,
          moduleName:"Contracts",
          from:`/procurement/contracts`,
          editLink:"/procurement/contracts/edit/",
          viewLink:"/procurement/contracts/view/"
        }
      },
    ];

    const availableHeaders = [
      {
        title: "ID",
        width: "5%",
        field: "id",
        textAlign: "left",
        rowAlign: "left",
      },
      {
        title: "Contract Title",
        width: "10%",
        isLink: true,
        id: "id",
        link: '/procurement/contracts/view/',
        field: "contractTitle",
        textAlign: "left",
        rowAlign: "left",
      },
      {
        title: "Customer Name",
        width: "10%",
        field: "customerName",
        textAlign: "left",
        rowAlign: "left",
      },
      {
        title: "Start Date",
        width: "10%",
        field: "startDate",
        textAlign: "left",
        rowAlign: "left",
      },
      {
        title: "End Date",
        width: "10%",
        field: "endDate",
        textAlign: "left",
        rowAlign: "left",
      },
      {
        title: "Project Duration",
        width: "10%",
        field: "projectDuration",
        textAlign: "left",
        rowAlign: "left",
      },
      {
        title: "Status",
        width: "10%",
        field: "status",
        textAlign: "left",
        rowAlign: "left",
      },
      {
        title: "Additional Amount",
        width: "10%",
        field: "additionalAmount",
        textAlign: "left",
        rowAlign: "left",
      },
      // {
      //   title: "Comments",
      //   width: "10%",
      //   field: "comments",
      //   textAlign: "left",
      //   rowAlign: "left",
      // },
      {
        title: "Contract Amount",
        width: "10%",
        field: "contractAmount",
        textAlign: "left",
        rowAlign: "left",
      },
      {
        title: "Receivables",
        width: "10%",
        field: "receivables",
        textAlign: "left",
        rowAlign: "left",
      },
      {
        title: "Scope Of Work",
        width: "10%",
        field: "scopeOfWork",
        textAlign: "left",
        rowAlign: "left",
      },
      {
        title: "Signed On",
        width: "10%",
        field: "signedOn",
        textAlign: "left",
        rowAlign: "left",
      },
      {
        title: "Total Amount",
        width: "10%",
        field: "totalAmount",
        textAlign: "left",
        rowAlign: "left",
      },
      {
        title: "Action",
        width: "5%",
        field: "action",
        textAlign: "left",
        rowAlign: "left",
        contents:{
          // fetcher:getData,
          id:"id",
          removeValue:"contractTitle",
          url:`/contracts/`,
          moduleName:"Contracts",
          from:`/procurement/contracts`,
          editLink:"/procurement/contracts/edit/",
          viewLink:"/procurement/contracts/view/"
        }
      },
    ];
  
      const closeFilterDialog = () => {
        setShowFilterDialog(false);
      };
    const canEdit = GetAccess("contracts_edit") || GetRole();
    const canDelete = GetAccess("contracts_delete") || GetRole();
    const { handle: handleDelete } = useDeleteData(getData);

    return (
      <div className='w-full h-full px-4 py-2'>
      <div className='w-full flex justify-between items-center'>
      <Breadcrumb
         items={
          [
            { name: "Procurement" },
            {
            name: "Contracts",
          }]
         }
        />
      <div className=' flex gap-2'>
      <SearchBar handleChange={(e) => setParams({...params,search:e.target.value})} />
          <FilterButton  handleClick={()=>setShowFilterDialog(true)} />
          {filter && <FilterButton  handleClick={()=>clearFilter()} label='Clear'/>}
        
          {/* Table / Card View Toggle */}
          <div className="flex bg-gray-100 p-0.5 rounded-lg border border-gray-200/50 shadow-sm select-none">
            <button
              onClick={() => {
                setViewMode("table");
                localStorage.setItem("contractsViewMode", "table");
              }}
              className={`px-3 py-1.5 rounded-md flex items-center gap-1.5 text-xs font-semibold transition-all ${
                viewMode === "table"
                  ? "bg-white text-gray-800 shadow-sm"
                  : "text-gray-500 hover:text-gray-800"
              }`}
              title="Table View"
            >
              <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
              </svg>
              Table
            </button>
            <button
              onClick={() => {
                setViewMode("card");
                localStorage.setItem("contractsViewMode", "card");
              }}
              className={`px-3 py-1.5 rounded-md flex items-center gap-1.5 text-xs font-semibold transition-all ${
                viewMode === "card"
                  ? "bg-white text-gray-800 shadow-sm"
                  : "text-gray-500 hover:text-gray-800"
              }`}
              title="Card View"
            >
              <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
              </svg>
              Cards
            </button>
          </div>
         
       <CreateButton label='Import' />
       <Link to="/procurement/contracts/create"><CreateButton label='Contracts'/></Link> 
      </div>
      </div>
  
      <PremiumTable 
        data={data}
        total={totalCount}
        pageIndex={page}
        setPageIndex={setPage}
        dataCount={pageCount}
        setDataCount={setPageCount}
        viewMode={viewMode}
        headers={[
          { title: "ID", width: "80px" },
          { title: "Contract Title", width: "auto" },
          { title: "Customer Name", width: "180px" },
          { title: "Start Date", width: "140px" },
          { title: "End Date", width: "140px" },
          { title: "Project Duration", width: "140px" },
          { title: "Status", width: "120px" },
          { title: "Action", align: "center", width: "100px" }
        ]}
        renderRow={(row, idx) => (
          <ContractTableRow
            row={row}
            pageIndex={page}
            searchQuery={params?.search || ""}
            canEdit={canEdit}
            canDelete={canDelete}
            handleDelete={handleDelete}
          />
        )}
        renderCard={(row, idx) => (
          <ContractCard
            row={row}
            pageIndex={page}
            searchQuery={params?.search || ""}
            canEdit={canEdit}
            canDelete={canDelete}
            handleDelete={handleDelete}
          />
        )}
        dataLoading={dataLoading}
      />
          {showFilterDialog && (
             
             
             <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
               <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
                 <h2 className="text-xl mb-4">Filter Catalogues</h2>
                 <form onSubmit={formik.handleSubmit}> 
                    <div className="flex flex-col mb-4">
                      <FormikSelectTwo 
                        label="Category"
                        placeholder="Choose"
                        Options={[
                          {
                            value: "Option1", label: "Option1"
                          },
                          {
                            value: "Option2", label: "Option2"
                          }
          
                        ]}
                        formik={formik}
                        name="category"
                        width="w-full"
                      />
                      <FormikSelectTwo 
                        label="Sub Category"
                        placeholder="Choose"
                        Options={[
                          {
                            value: "Option1", label: "Option1"
                          },
                          {
                            value: "Option2", label: "Option2"
                          }
          
                        ]}
                        formik={formik}
                        name="subCategory"
                        width="w-full"
                      />
                    </div>
                   <div className="flex justify-end gap-2">
                     <CancelButton handleClick={closeFilterDialog} />
                     <SubmitButton name='Apply' />
                   </div>
                  </form> 
               </div>
             </div>
           )}
    </div>
    )
}

export default ContractsIndex;